export const buildQueryParams = (params) => {
    const { filters, query, application, identifier, except, skip, limit, } = params;
    const queryParams = Object.assign(Object.assign(Object.assign(Object.assign({ application,
        identifier }, (except ? { except } : {})), (filters !== null && filters !== void 0 ? filters : {})), { $skip: skip !== null && skip !== void 0 ? skip : 0, $limit: limit !== null && limit !== void 0 ? limit : 20 }), (query ? { $query: query } : {}));
    return queryParams;
};
//# sourceMappingURL=buildQueryParams.js.map